import { MutableRefObject, useEffect, useState } from 'react'
import useIsMountedRef from 'use-is-mounted-ref'
import { ReactState } from '../Types/Types'
import { LoginLandingPageFlags } from '../../../NonReact/Types/Types'
import { requestGetJSON } from '../../../NonReact/common/API/REST/RESTAPIClient'
import { LOGIN_LANDING_PAGE_FLAGS_URL } from '../../../NonReact/constants/ApiConstants'
import { $error } from '../Utils/ConsoleUtils'

export const useLoginLandingPageFlags = (): Nullable<LoginLandingPageFlags> => {
    const isMounted: MutableRefObject<boolean> = useIsMountedRef()
    const [loginLandingPageFlags, setLoginLandingPageFlags]: ReactState<Nullable<LoginLandingPageFlags>> =
        useState<Nullable<LoginLandingPageFlags>>(null)

    useEffect((): void => {
        requestGetJSON<LoginLandingPageFlags>(LOGIN_LANDING_PAGE_FLAGS_URL, { cacheTime: 10000 })
            .then((flags: Nullable<LoginLandingPageFlags>): void => {
                if (isMounted.current) {
                    setLoginLandingPageFlags(flags)
                }
            })
            .catch($error)
    }, [])

    return loginLandingPageFlags
}
